export default {
    data() {
        return {
            media_path: 'https://media.pafcpic.ph/images/',
        }
    }
}